<template>
    <div class="page">
        <div class="ctrl">
            <a-button type="primary" @click="show_create = true">添加门票</a-button>
        </div>
        <a-table class="sec" size="small" :rowKey="(record) => record.id" bordered :columns="columns"
            :data-source="list" :pagination="false">
            <template slot="youxiaoshijian" slot-scope="text, record">
                {{ record.start_time }} ~ {{ record.end_time }}
            </template>
            <template slot="zhuangtai" slot-scope="text, record">
                <template v-if="record.status == 1"> 开启 </template>
                <template v-if="record.status == 2"> 关闭 </template>
                <template></template>
            </template>

            <template slot="options" slot-scope="text, record">
                <a-button v-if="record.status == 1" type="primary" size="small"
                    @click="updateStatus(record.id, 2)">关闭</a-button>
                <a-button v-if="record.status == 2" type="primary" size="small"
                    @click="updateStatus(record.id, 1)">开启</a-button>
                <a-divider type="vertical" />
                <a-button type="primary" size="small" @click="showErweima(record)">二维码</a-button>
                <!-- <a-divider type="vertical" />
                <a-button size="small" @click="showBeizhu(record.desc)">备注</a-button> -->
                <a-divider type="vertical" />
                <a-button type="primary" size="small" @click="showCreate(record.id)">编辑</a-button>

                <a-divider type="vertical" />
                <a-button type="primary" size="small" @click="toTongji(record.id)">统计</a-button>

                <a-divider type="vertical" />
                <a-button type="primary" size="small" @click="showZengsong(record.id)">赠送</a-button>

                <a-divider type="vertical" />
                <a-popconfirm title="确定要删除吗？" ok-text="确定" cancel-text="取消" @confirm="updateStatus(record.id, 0)">
                    <a-button type="danger" size="small">删除</a-button>
                </a-popconfirm>
            </template>
        </a-table>

        <CreateModal v-if="show_create" :exh_id="exh_id" :id="createModel.id" :couponList="couponList" @callback="added" />

        <a-modal :visible="beizhu.show" title="备注" @ok="cancelBezhu" @cancel="cancelBezhu">
            <a-form :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-form-item label="备注">
                    {{ beizhu.desc }}
                </a-form-item>
            </a-form>
        </a-modal>

        <a-modal :title="'二维码'" :width="800" :okText="'下载'" :visible="qrCode.show" @ok="xiazaiQrcode"
            @cancel="cancelCode">
            <div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
                <img style="width: 500px;margin: 0 auto;" :src="qrCode.img" />
            </div>
            <!-- <a-button size="small" type="primary" @click="xiazaiQrcode">下载二维码</a-button> -->
        </a-modal>

        <a-modal :visible="zengSong.show" :width="1000" title="赠送门票" @ok="doZengsong" @cancel="cancelZengsong">
            <div class="flex-page" style="max-height: 60vh; overflow: auto; display: flex; flex-direction: column;">
                <a-form class="ctrl" layout="inline">
                    <a-form-item label="姓名">
                        <a-input style="width: 200px" placeholder="请输入姓名" v-model="zengSong.search.name"></a-input>
                    </a-form-item>
                    <a-form-item label="电话">
                        <a-input style="width: 200px" placeholder="请输入电话" v-model="zengSong.search.tel"></a-input>
                    </a-form-item>
                    <a-form-item label="昵称">
                        <a-input style="width: 200px" placeholder="请输入微信昵称"
                            v-model="zengSong.search.nickName"></a-input>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" @click="searchZengsong">搜索</a-button>
                    </a-form-item>
                </a-form>

                <div class="statistics">共{{ zengSong.list.length }}个,选中{{ selectedRowKeys.length }}个</div>

                <a-table style="min-height: 0; flex: 1; overflow: auto;" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" class="main"
                    size="small" :rowKey="(record) => record.id" bordered :columns="zengsongColumns"
                    :data-source="zengSong.list" :pagination="false">
                    <template slot="weixin" slot-scope="text, record">
                        <div
                            style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                            <img :src="record.headimgurl" style="width: 40px;" alt="">
                            <div>{{ record.nickname }}</div>
                        </div>
                    </template>
                </a-table>

                <a-pagination class="pagination" style="margin-top: 10px; margin-bottom: unset;" showQuickJumper
                    v-model="zengSong.page.now_page" :defaultPageSize="zengSong.page.page_size"
                    :total="zengSong.page.amount" @change="changeZengsongPage" />
            </div>
        </a-modal>

    </div>
</template>

<style lang='scss' scoped></style>

<script>
import CreateModal from "./create";
import QRCode from "qrcode";
export default {
    components: { CreateModal },
    data() {
        return {
            formItemLayout: {
                labelCol: {
                    span: 4,
                },
                wrapperCol: {
                    span: 19,
                },
            },
            columns: [
                {
                    title: "#",
                    dataIndex: "id",
                },
                {
                    title: "标题",
                    dataIndex: "title",
                },
                // {
                //     title: "类型",
                //     dataIndex: "type",
                // },
                {
                    title: "价格",
                    dataIndex: "price",
                },
                {
                    title: "限制张数",
                    dataIndex: "limit",
                },
                {
                    title: "有效时间",
                    scopedSlots: {
                        customRender: "youxiaoshijian",
                    },
                },
                {
                    title: "状态",
                    scopedSlots: {
                        customRender: "zhuangtai",
                    },
                },
                {
                    title: "操作",
                    scopedSlots: {
                        customRender: "options",
                    },
                },
            ],
            zengsongColumns: [
                {
                    title: "#",
                    dataIndex: "id",
                },
                {
                    title: "微信",
                    scopedSlots: {
                        customRender: "weixin",
                    },
                },
                {
                    title: "姓名",
                    dataIndex: "name",
                },
                {
                    title: "电话",
                    dataIndex: "tel",
                },
            ],
            exh_id: null,
            list: [],
            show_create: false,
            createModel: {
                id: null
            },
            beizhu: {
                show: false,
                desc: ''
            },
            qrCode: {
                show: false,
                img: null,
                title: null
            },
            zengSong: {
                show: false,
                menpiao_id: null,
                search: {
                    nickName: '',
                    tel: '',
                    name: ''
                },
                page: {
                    now_page: 1,
                    page_size: 50,
                    amount: 0,
                },
                list: []
            },
            selectedRowKeys: [],
            couponList: []
        };
    },
    computed: {
        rowSelection() {
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                },
                getCheckboxProps: record => ({
                    props: {
                        disabled: record.name === 'Disabled User', // Column configuration not to be checked
                        name: record.name,
                    },
                }),
            };
        },
    },
    async created() {
        this.exh_id = this.$route.query.exh_id;
        this.getList();
        this.getYouhuiquan()
    },
    methods: {
        async getList() {
            const r = await this.$axios.get("/exh/menpiao/list?exh_id=" + this.exh_id);
            if (r.status == 1) this.list = r.list;
        },

        async getYouhuiquan() {
            const r2 = await this.$axios.get('/activity/getCouponList');
            this.couponList = r2.list;
        },

        added(e) {
            this.show_create = false;
            this.createModel.id = null
            if (e) this.getList();
        },

        async updateStatus(id, status) {
            const r = await this.$axios.post("/exh/menpiao/updateStatus", {
                id,
                status
            });

            if (r.status == 1) {
                this.getList();
            }
        },

        showCreate(id) {
            this.createModel.id = id
            this.show_create = true
        },

        cancelBezhu() {
            this.beizhu.show = false
            this.beizhu.desc = ''
        },

        showBeizhu(desc) {
            this.beizhu.show = true
            this.beizhu.desc = desc
        },

        showErweima(record) {
            // console.log(this.$config.wechatApi + '/exh/yanpiao/list?exh_id=' + String(record.id) + '&is_saoma=1')
            QRCode.toDataURL(this.$config.wechatApi + '/exh/yanpiao/list?exh_id=' + String(record.exh_id) + '&is_saoma=1', { errorCorrectionLevel: 'L', margin: 2, width: 800 }, (err, url) => {
                if (err) throw err
                this.qrCode.img = url
            })
            this.qrCode.show = true
            this.qrCode.title = record.title
        },

        cancelCode() {
            this.qrCode = {
                show: false,
                img: null,
                title: null
            }
        },

        xiazaiQrcode() {
            const a = document.createElement('a')
            const filename = this.qrCode.title + '二维码.png'
            a.href = this.qrCode.img  // picSrc  是图片 base64 码，可以直接给 img 的 src 属性，展示图片
            a.download = filename
            document.body.appendChild(a)
            a.click()
            setTimeout(() => {
                document.body.removeChild(a)
            }, 1000)
        },

        toTongji(menpiao_id) {
            this.$router.push('/exhMenpiao/tongji?id=' + menpiao_id)
        },

        async searchZengsong() {
            if (!this.zengSong.search.nickName && !this.zengSong.search.tel && !this.zengSong.search.name) {
                this.$message.error('请至少输入一个搜索条件!')
                return
            }
            const options = { ...this.zengSong.search }
            options.nowPage = this.zengSong.page.now_page;
            const r = await this.$axios.post("/exh/menpiao/searchZengsong", options);
            this.zengSong.list = r.list
            this.zengSong.page.amount = r.amount
        },

        async doZengsong() {
            if(this.selectedRowKeys.length == 0) {
                this.$message.error('请选择要赠送的用户')
                return
            }
            const r = await this.$axios.post("/exh/menpiao/doZengsong", {
                menpiao_id: this.zengSong.menpiao_id,
                zengsongs: this.selectedRowKeys
            });
            if(r.status == 1) {
                this.cancelZengsong()
                this.selectedRowKeys = []
            }
        },

        cancelZengsong() {
            this.zengSong = {
                show: false,
                menpiao_id: null,
                search: {
                    nickName: '',
                    tel: '',
                    name: ''
                },
                page: {
                    nowPage: 1,
                    amount: 0
                },
                list: [],
            }
        },

        showZengsong(menpiao_id) {
            this.zengSong.menpiao_id = menpiao_id
            this.zengSong.show = true
        },

        changeZengsongPage(e) {
            this.zengSong.page.now_page = e;
            this.searchZengsong();
            this.selectedRowKeys = []
        },

        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        }
    },
};
</script>

<style></style>